import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { CarrierLoginComponent } from './pages/login/carrier-login.component';
import { CookieBannerModule } from '@pw-cookie-banner/cookie-banner.module';
import { PwSpinnerModule } from '@pw-spinner/pw-spinner.module';
import { PwTranslateLoader } from '@pw-translate-loader';
import { LoginRoutingModule } from './login-routing.module';
import { ForgotPasswordModule } from '@utils/src/forgot-password/forgot-password.module';

@NgModule({
  declarations: [CarrierLoginComponent],
  imports: [
    CommonModule,
    LoginRoutingModule,
    CookieBannerModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    TranslateModule,
    PwSpinnerModule,
    ForgotPasswordModule,
  ],
})
export class LoginModule {
  constructor(private _translateLoader: PwTranslateLoader) {
    this._translateLoader.addModule({ name: 'login', relateLocation: 'pickwings-carrier/login' });
  }
}
